import { API_URL, CONTACT_EMAIL } from "../config.js";

/**
 * POSTs JSON to `${API_URL}/forms/<kind>`  (kind: contact | discovery-call | newsletter | seller-listing)
 * Expected: 2xx on success. If API_URL is unset, falls back to mailto (not for newsletter).
 */
export async function submitForm(kind, data) {
  if (!API_URL) {
    if (kind === "newsletter") return { ok: false, error: "Signup is not configured yet." };
    const body = Object.entries(data).map(([k, v]) => `${k}: ${v}`).join("\n");
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Website: " + kind)}&body=${encodeURIComponent(body)}`;
    return { ok: true, fallback: true };
  }
  try {
    const res = await fetch(`${API_URL.replace(/\/$/, "")}/forms/${kind}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...data, source: window.location.pathname }),
    });
    return res.ok ? { ok: true } : { ok: false, error: "Something went wrong. Please try again." };
  } catch (e) {
    return { ok: false, error: "Network error. Please try again." };
  }
}
